import { createFileRoute } from '@tanstack/react-router';

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/analytics/roi/appointment-reminders')({ staticData: { team: 'analytics' } });
